import React from 'react';
import PropTypes from 'prop-types';
import PersonOutlined from '@mui/icons-material/PersonOutlined';
import colors from '../Theme/colors';

const userProperties = {
  title: PropTypes.string.isRequired,
};

type UserProperties = PropTypes.InferProps<typeof userProperties> & {
  fillColor?: string;
};

const User = ({
  title,
  fillColor,
  ...properties
}: UserProperties) => (
  <PersonOutlined
    titleAccess={title}
    htmlColor={fillColor ?? colors.greyDark}
    {...properties}
  />
);

User.propTypes = userProperties;

export default User;
